/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DataService as ɵa} from './lib/services/data.service';